module.exports = __webpack_public_path__ + "img/qrcode-qxkt-download.cbac5abd.png";